import "./Music.css"
import { useBackground } from '../BackgroundContext';
import { useEffect, useState } from 'react';


function Music() {
  const { theme } = useBackground();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [screenWidth] = useState(window.innerWidth);

  
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Browser detection
const userAgent = navigator.userAgent.toLowerCase();
const isSafari = /^((?!chrome|android).)*safari/.test(userAgent);
const isChrome = /chrome/.test(userAgent) && !/edge|edg|opr/.test(userAgent);
const isFirefox = /firefox/.test(userAgent);

// Clamp helper
const clamp = (val, min, max) => Math.min(max, Math.max(min, val));

// Custom scroll behavior based on browser
let stretchFactor;
let fontSize

if (screenWidth <= 500) {
  stretchFactor = clamp(1 + (scrollPosition - 2500) / 50, 0, 15);
  fontSize = `${clamp(1 + (stretchFactor * 0.5), 1.5, 15)}em`;
} else {
if (isSafari) {
  stretchFactor = clamp(1 + (scrollPosition - 2900) / 50, 0, 5);
  fontSize = `${clamp(1 + (stretchFactor * 0.5), 1.5, 9)}em`;
} else if (isChrome) {
  stretchFactor = clamp(1 + (scrollPosition - 2900) / 50, 0, 5);
  fontSize = `${clamp(1 + (stretchFactor * 0.5), 1.5, 9)}em`;
} else if (isFirefox) {
  stretchFactor = clamp(1 + (scrollPosition - 2800) / 50, 0, 5);
  fontSize = `${clamp(1 + (stretchFactor * 0.5), 1.5, 9)}em`;
} else {
  // fallback for other browsers
  stretchFactor = clamp(1 + (scrollPosition - 2400) / 50, 0, 5);
}
}

  

// const startFade = 2000;
// const endFade = 1980;

// const fadeProgress = Math.min(
//   1, Math.max(0, (scrollPosition - startFade) / (endFade - startFade))
// );

// const opacity = 1 - fadeProgress;

  return (
    <div id="Music" className="coming-soon-page" 
    // style={{
    //   opacity,
    //   transition: 'opacity 0.7s ease-in-out'
    // }}
    >
      <div>
        <p>Page</p>
        <span>COMING</span>
        <span aria-hidden="true" style={{fontSize, transition: 'font-size 0.3s ease-out'}}>
          <span>S</span>
          <span 
          style={{
            border: `0.25ch solid ${
              theme.background === '#2e2e2e' ? 'white' : '#2e2e2e'}`, '--stretch': stretchFactor
          }}
          className="stretch-o">

          </span>
          <span>O</span>
          <span>N</span>
        </span>
        <span className="sr-only">SOON</span>
      </div>
          {/* <span className="stay-tune" style={{
          fontSize: fontSizeMessage,
          transition: 'font-size 0.3s ease-out'
        }}>Stay tuned</span> */}
    </div>
    // <div className="music-page">
        // <div className="flute-pic">
           // <img alt="" src="/Images/music2.jpeg"></img>
       // </div> 
      // <div className="music-title"> 
        // </div> 
    // </div>
  );
};

export default Music;